import React from "react";
import { Headline1 } from "@material/react-typography";
import "./Placeholder.scss";

export const Placeholder: React.FC = ({ children }) => (
  <Headline1 className="placeholder">{children}</Headline1>
);
